import type { FaireProductEntity } from "../../entity_types/product";

export const driftless_studios_16: FaireProductEntity = {
  token: "driftless-studios-16",
  type: "product",
  name: "32x16 What A Wonderful World Horizontal Wood Sign",
  brandName: "Driftless Studios",
  imageUrl:
    "https://cdn.faire.com/fastly/95e482bc85d8be9e5e2d95b8c772a65d75a8469957bce039b29c8ee19139a805.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=960&width=720",
  priceDollars: 38.5,
  msrpDollars: 68,
  freeShipping: true,
  isBestseller: true,
  description: "",
  categoryTokens: ["cat_proto_home-and-living"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
